import { makeStyles, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import { CheckoutSessionCriteria, CreditCardCriteria, LoanCriteria, Merchant } from '@nemuru-eng/js-api-client';

import { CheckoutSessionSearchResultCard } from '@/components/shared/components/SuperSearchBar/components/SearchResultCard/components/CheckoutSessionSearchResultCard';
import { CreditCardSearchResultCard } from '@/components/shared/components/SuperSearchBar/components/SearchResultCard/components/CreditCardSearchResultCard';

import { SearchBarFilterOptions } from '../../types/SearchBarFilterOptions';
import { SearchResult } from '../../types/SearchResult';
import { ApplicationSearchResultCard } from './components/ApplicationSearchResultCard';
import { MerchantSearchResultCard } from './components/MerchantSearchResultCard';

interface SearchResultCardProps {
  selected: boolean;
  searchResult: SearchResult;
  searchBarState: SearchBarFilterOptions;
  toggleDialog: () => void;
  onNavigate?: boolean;
}

export const SearchResultCard = ({
  selected,
  searchResult,
  searchBarState,
  toggleDialog,
  onNavigate,
}: SearchResultCardProps) => {
  const classes = useStyles();
  return (
    <>
      {isLoanCriteria(searchResult) && (
        <ApplicationSearchResultCard
          classes={classes}
          selected={selected}
          searchResult={searchResult}
          onNavigate={onNavigate}
          toggleDialog={toggleDialog}
          searchBarState={searchBarState}
        />
      )}
      {isCreditCardCriteria(searchResult) && (
        <CreditCardSearchResultCard
          classes={classes}
          selected={selected}
          searchResult={searchResult}
          onNavigate={onNavigate}
          toggleDialog={toggleDialog}
          searchBarState={searchBarState}
        />
      )}
      {isMerchant(searchResult) && (
        <MerchantSearchResultCard
          classes={classes}
          selected={selected}
          searchResult={searchResult}
          onNavigate={onNavigate}
          toggleDialog={toggleDialog}
        />
      )}
      {isCheckoutSessionCriteria(searchResult) && (
        <CheckoutSessionSearchResultCard
          classes={classes}
          selected={selected}
          searchResult={searchResult}
          onNavigate={onNavigate}
          toggleDialog={toggleDialog}
          searchBarState={searchBarState}
        />
      )}
    </>
  );
};

const isLoanCriteria = (searchResult: SearchResult): searchResult is LoanCriteria => {
  return 'order' in searchResult || 'loanConditions' in searchResult;
};

const isMerchant = (searchResult: SearchResult): searchResult is Merchant => {
  return 'approvalStatus' in searchResult;
};

const isCreditCardCriteria = (searchResult: SearchResult): searchResult is CreditCardCriteria => {
  return 'isLoan' in searchResult && searchResult.isLoan === false;
};

const isCheckoutSessionCriteria = (searchResult: SearchResult): searchResult is CheckoutSessionCriteria => {
  return 'selectedPaymentIntent' in searchResult;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:hover': { backgroundColor: theme.palette.grey[200] },
    },
  }),
);
